export default __webpack_public_path__ + "static/media/explore-my-cover.f7d863e5.svg";